export const ParamKeys = {
  PARAMETRO_SISTEMA_VALIDADE_EM_DIAS: 'PARAMETRO_SISTEMA_VALIDADE_EM_DIAS',
  PARAMETRO_SISTEMA_REFAZER_PREAVALIACAO_SEGUNDOS:
    'PARAMETRO_SISTEMA_REFAZER_PREAVALIACAO_SEGUNDOS',
  PARAMETRO_SISTEMA_IDADE_MAXIMA: 'PARAMETRO_SISTEMA_IDADE_MAXIMA',
  LIVENESS_OITI_HABILITADO: 'LIVENESS_OITI_HABILITADO',
  CREDENCIAL_LIVENESS: 'CREDENCIAL_LIVENESS',
};
